


















import { Component, Vue, Prop } from 'vue-property-decorator'
import { Game } from '@/class/game'
import { GamePlayer } from '@/class/gamePlayer'
import Timer from './Timer.vue'
import BtnSquare from '@/components/Utils/form/button/BtnSquare.vue'

@Component({
  components: {
    Timer,
    BtnSquare
  }
})

export default class Header extends Vue {
  @Prop() game!: Game;
  @Prop() isGallary!: boolean;
  @Prop() playerSelf?: GamePlayer;

  get stateLabel (): string {
    return this.game.stateLabel
  }

  get isTimeOver () {
    return this.game.limitDate.getTime() < new Date().getTime()
  }

  get isTurnEnd () {
    return this.playerSelf?.turnEnd
  }

  toggleTurnEnd () {
    if (!this.playerSelf) {
      return
    }

    this.playerSelf.updateTurnEnd(!this.playerSelf.turnEnd)
  }

  get canTurnEnd (): boolean {
    if (this.isTimeOver) {
      return false
    }

    return this.game.activePlayers.filter((player) => {
      if (!this.playerSelf) {
        return false
      } else {
        return player.id === this.playerSelf.id
      }
    }).length > 0
  }
}
